(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 550px)';
  var DESCRIPTION_DESKTOP_LIMIT = 340;
  var DESCRIPTION_MOBILE_LIMIT = 280;

  function enhanceDescription(source) {
    if (!source || source.dataset.agfnDescriptionEnhanced === 'true') return;
    if (source.offsetParent === null) return;
    if (source.parentElement && source.parentElement.querySelector('.tab-showMore')) return;

    var limit = window.matchMedia(MOBILE_QUERY).matches
      ? DESCRIPTION_MOBILE_LIMIT
      : DESCRIPTION_DESKTOP_LIMIT;

    if (source.scrollHeight <= limit + 28) return;

    source.dataset.agfnDescriptionEnhanced = 'true';
    source.classList.add('is-collapsible', 'is-collapsed');

    var actions = document.createElement('div');
    actions.className = 'agfn-description-actions';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'agfn-description-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'READ FULL DESCRIPTION';

    button.addEventListener('click', function () {
      var willExpand = source.classList.contains('is-collapsed');
      source.classList.toggle('is-collapsed', !willExpand);
      source.classList.toggle('is-expanded', willExpand);
      button.setAttribute('aria-expanded', String(willExpand));
      button.textContent = willExpand ? 'SHOW LESS' : 'READ FULL DESCRIPTION';

      if (!willExpand) {
        window.requestAnimationFrame(function () {
          source.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });

    actions.appendChild(button);
    source.insertAdjacentElement('afterend', actions);
  }

  function enhanceLabReports(source) {
    if (!source || source.dataset.agfnReportsEnhanced === 'true') return;
    source.dataset.agfnReportsEnhanced = 'true';

    var links = source.querySelectorAll('a[href]');
    links.forEach(function (link, index) {
      if (link.classList.contains('agfn-report-card')) return;

      var originalText = link.textContent.replace(/\s+/g, ' ').trim();
      var isGeneric = !originalText || /^(https?:\/\/|www\.|view|click here|lab report|report)$/i.test(originalText);
      var reportTitle = isGeneric
        ? (links.length > 1 ? 'Product lab report ' + (index + 1) : 'Product lab report')
        : originalText;

      link.classList.add('agfn-report-card');
      link.textContent = '';
      if (link.target === '_blank') link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', reportTitle + ', view lab report');

      var icon = document.createElement('span');
      icon.className = 'agfn-report-card__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M7 2.75h7.5L19.25 7.5V21.25H7z"/><path d="M14.5 2.75V7.5h4.75M9.75 12h6.5M9.75 15.5h6.5"/></svg>';

      var copy = document.createElement('span');
      copy.className = 'agfn-report-card__copy';
      var title = document.createElement('strong');
      title.textContent = reportTitle;
      var action = document.createElement('small');
      action.textContent = 'VIEW LAB REPORT';
      copy.appendChild(title);
      copy.appendChild(action);

      var arrow = document.createElement('span');
      arrow.className = 'agfn-report-card__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '\u2192';

      link.appendChild(icon);
      link.appendChild(copy);
      link.appendChild(arrow);

      var parent = link.parentElement;
      if (parent && parent.children.length === 1 && parent.textContent.trim() === link.textContent.trim()) {
        parent.classList.add('agfn-report-entry');
      }
    });
  }

  function enhanceTabs(root) {
    root.querySelectorAll('[data-agfn-tab="description"] .agfn-description-source').forEach(enhanceDescription);
    root.querySelectorAll('[data-agfn-tab="lab-reports"] .agfn-tab-source').forEach(enhanceLabReports);
  }

  function scheduleEnhancement(root) {
    window.requestAnimationFrame(function () {
      window.setTimeout(function () { enhanceTabs(root); }, 30);
    });
  }

  function initialize() {
    document.querySelectorAll('product-tab.halo-product-tab').forEach(function (root) {
      enhanceTabs(root);
      root.addEventListener('click', function () { scheduleEnhancement(root); });

      var observer = new MutationObserver(function () { scheduleEnhancement(root); });
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
